import { inject, Injectable } from '@angular/core'

import type { UsersListParams } from '@app/generated/api/model'
import { UsersService } from '@app/generated/api/users/users.service'

@Injectable({
  providedIn: 'root',
})
export class UsersApi {
  private readonly usersService = inject(UsersService)

  list (params: any) {
    return this.usersService.list(params as UsersListParams) as any
  }

  retrieve (username: string) {
    return this.usersService.retrieve(username) as any
  }
}
